(() => {
  const configElement = document.getElementById('fr-lead-copy-config');
  if (!configElement) return;
  let copy;
  try { copy = JSON.parse(configElement.textContent); } catch { return; }
  if (!['intro', 'heading', 'success'].every(key => typeof copy[key] === 'string' && copy[key])) return;
  const ids = ["RxbsyL","SGAhsC","XsQTms","TeY5HR","WcNN8c","XndD24","UWLGSW","XhAnEE","TC7mii","YnmXd8","SUt4kh","XyTTNZ","XA6pTH","Y8ucaW"];
  const selector = ids.map(id => '.klaviyo-form-' + id).join(',');
  const normalize = value => value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const replacements = new Map([
    ['Enter your email and mobile number. We’ll text your $20 code immediately.', copy.intro],
    ['CHECK YOUR PHONE—YOUR $20 CODE IS ON THE WAY', copy.heading],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Kappa Alpha Psi jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Alpha Phi Alpha jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Omega Psi Phi jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Phi Beta Sigma jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Iota Phi Theta jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Delta Sigma Theta jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Zeta Phi Beta jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Kappa Kappa Psi jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Masons/Prince Hall jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on U.S. Army jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on U.S. Air Force jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on U.S. Marine Corps jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Order Eastern Star jewelry.", copy.success],
    ["We’re sending your unique $20 code by text and email now. Use it within 5 hours on Shriners jewelry.", copy.success]
  ]);
  const applyCopy = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('script,style,textarea,input,button,label,[role="checkbox"]')) continue;
      const replacement = replacements.get(normalize(node.data));
      if (replacement && node.data !== replacement) node.data = replacement;
    }
  };
  const inspect = node => {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const root = element.closest(selector);
    if (root) applyCopy(root);
    element.querySelectorAll(selector).forEach(applyCopy);
  };
  const observer = new MutationObserver(records => {
    const roots = new Set();
    records.forEach(record => {
      if (record.type === 'characterData') roots.add(record.target);
      record.addedNodes.forEach(node => roots.add(node));
    });
    roots.forEach(inspect);
  });
  const start = () => {
    document.querySelectorAll(selector).forEach(applyCopy);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
